import { Box, Grid, IconButton, SxProps, Tooltip, Typography } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import styled from '@mui/system/styled';
import InfoIcon from '@mui/icons-material/Info';
import { DropzoneInputProps } from 'react-dropzone';
import { ReactNode } from 'react';
import { Button } from '@baseComponents';

const TooltipInfo = styled(Box)({
  '&': {
    padding: 5,
    maxWidth: 175,
    paddingLeft: 15,
    margin: 0
  }
});

interface ImageSelectorProps {
  dropzoneInputProps: DropzoneInputProps;
  explanation?: string;
  tooltipContent: ReactNode;
  disabled?: boolean;
  buttonText?: string;
  buttonSx?: SxProps;
  infoIcon?: ReactNode;
  infoIconButtonSx?: SxProps;
  disableInfoRipple?: boolean;
}

const ImageSelector = ({
  dropzoneInputProps,
  explanation,
  tooltipContent,
  disabled = false,
  buttonText = 'Upload Photo',
  buttonSx,
  infoIcon = <InfoIcon />,
  infoIconButtonSx,
  disableInfoRipple = false
}: ImageSelectorProps) => (
  <Box>
    <Grid
      container
      direction='row'
      wrap='wrap'
      sx={{
        alignItems: 'center',
        gap: 1
      }}>
      <Button
        mode='outlined'
        text={buttonText}
        startIcon={<UploadFileIcon fontSize='small' sx={{ marginRight: 1 }} />}
        disabled={disabled}
        sx={buttonSx}
      />

         <Tooltip title={<TooltipInfo>{tooltipContent}</TooltipInfo>}>
        <IconButton aria-label='upload photo' disableRipple={disableInfoRipple} sx={infoIconButtonSx}>
          {infoIcon}
        </IconButton>
      </Tooltip>
    </Grid>
    {explanation &&
      <Typography
        variant='bodySmall'
        sx={{
          display: 'inline-block',
          mt: 1
        }}>
        {explanation}
      </Typography>
    }
    <input
      style={{ display: 'none' }}
      {...dropzoneInputProps}
      aria-label='upload a photo for identity verification'
      disabled={disabled}
    />
  </Box>
);

export default ImageSelector;
